export class HTMLElementModel {
	public tag: string
	public childrens?: HTMLElementModel[] = []
	public parent: HTMLElementModel = null
	public content?: string = null
	public attributes?: string[] = null

	public constructor(tag: string) {
		this.tag = tag
	}
	public setChildren(children: HTMLElementModel): HTMLElementModel[] {
		this.childrens.push(children)
		return this.childrens
	}
	public setParent(parent: HTMLElementModel): HTMLElementModel {
		this.parent = parent
		return this.parent
	}

	public setContent(content: string): string {
		this.content = content
		return this.content
	}
	public setAttributes(attributes: string[]): string[] {
		this.attributes = attributes
		return this.attributes
	}
}
